import React from 'react';
import { Stack, Box, Typography, useTheme } from '@mui/material';
import { SanityFlavor } from 'src/types/sanity/types.sanity.product';

interface FlavorsProps {
  flavors: SanityFlavor[];
  get: string | null;
  set: (value: string | null) => void;
}

const Flavors = ({ flavors, get, set }: FlavorsProps) => {
  const theme = useTheme();

  if (!flavors || flavors.length === 0) return null;

  const handleSelect = (value: string) => {
    set(value);
  };

  const getFlavorColor = (flavor: string) => {
    switch (flavor) {
      case 'flavor_vanilla':
        return '#E2DCBA';
      case 'flavor_chocolate':
        return '#8C6E42';
      default:
        return '#EFEFEF';
    }
  };

  const getIcon = (flavor: string, selected: boolean) => (
    <Box
      sx={{
        width: 20,
        height: 20,
        borderRadius: '50%',
        bgcolor: getFlavorColor(flavor),
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        boxShadow: 'inset 0px 2px 3px rgba(0, 0, 0, 0.25)',
      }}
    >
      {selected && (
        <Box
          sx={{
            width: '60%',
            height: '60%',
            borderRadius: '50%',
            position: 'absolute',
          }}
        />
      )}
    </Box>
  );

  return (
    <Stack spacing={2}>
      <Typography variant={'h6'}>CHOOSE FLAVOR</Typography>
      <Box display={'flex'} gap={2} alignItems="stretch">
        {flavors.map((flavor, index) => {
          const selected = get === flavor.flavor;
          return (
            <Stack spacing={1} width={'100%'} key={index}>
              <Box
                height={'100%'}
                display={'flex'}
                flexShrink={1}
                gap={2}
                justifyContent={'space-between'}
                alignItems={'center'}
                onClick={() => handleSelect(flavor.flavor)}
                sx={{
                  padding: 1,
                  border: selected ? `1px solid ${theme.palette.primary.main}` : '1px solid grey',
                  borderRadius: '5px',
                  bgcolor: selected ? 'primary.light' : '#EEEFE6',
                  cursor: 'pointer',
                  display: 'flex',
                  width: '100%',
                  minHeight: 50, // Ensuring minimum height for consistency
                  '&:hover': {
                    bgcolor: 'primary.light',
                  },
                }}
              >
                <Box>{getIcon(flavor.flavor, selected)}</Box>
                <Box width={'100%'}>
                  <Typography variant="body2">{flavor.name}</Typography>
                </Box>
              </Box>
            </Stack>
          );
        })}
      </Box>
    </Stack>
  );
};

export default Flavors;
